module.exports = __webpack_public_path__ + "assets/img/info.png?727d24ddc1e195a7088ea6cf18361051";